export default __webpack_public_path__ + "static/media/aptitude@3x.9dac2862.png";